<template>
  <div>
    <folders-list-file-and-folder :hideFolders="true"></folders-list-file-and-folder>
  </div>
</template>

<script>
import FoldersListFileAndFolder from "@/components/folders/folders-list-file-and-folder";
export default {
  name: "folders-payment-files",
  components: {FoldersListFileAndFolder}
}
</script>

<style scoped>

</style>